import React from 'react';

export default class EhcParticipantsMiniTable extends React.Component {
  constructor(props) {
    super(props);
  }
  // =====================
  // Render Component
  // =====================
  render() {
    return (
      <div className="table-responsive mb-4" style={{maxHeight: "50vh", maxWidth: "100vw", overflow: "auto"}}>
        <table className="table table-bordered table-hover align-middle mb-0">
          <thead className="table-success">
            <tr>
              <th scope="col">Batch Code</th>
              <th scope="col">Service Package Name</th>
              <th scope="col">Name</th>
              <th scope="col">ID</th>
              <th scope="col">NIK</th>
              <th scope="col">Email</th>
            </tr>
          </thead>
          <tbody>
            {this.props.participants?.map((participant) => (
              <tr key={participant.id}>
                <td>{participant.order_name}</td>
                <td>{participant.service_package_name}</td>
                <td>{participant.profile_full_name}</td>
                <td>{participant.employment_id_number}</td>
                <td>{participant.profile_nik}</td>
                <td>{participant.profile_email}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}
